import { lazy } from "react";
// Provider Performance Module (Module M — BillingV2 Stage 2)
// PCP scorecards with internal peer comparison.

const ProviderPerformancePage = lazy(() => import("./pages/ProviderPerformancePage"));
// Export routes for AppRouter
export const providerPerformanceRoutes = [
  {
    path: "/provider-performance",
    element: <ProviderPerformancePage />,
  },
];

// Export components for external use
